import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import NextHead from 'next/head'
import { compose, getContext, withTranslation, i18n } from '@hocs'

import appUrl, { imageUrl, publicUrl } from '@libs/appUrl'
import { parserToContext } from '@libs/postTools'

import { PlaceType } from '@app-core/place/reducer'
import BreadcrumbJsonLD from '@components/jsonld/BreadcrumbJsonLD'

class PlaceHead extends PureComponent {
  static defaultProps = {
    place: {},
    placeType: '',
    router: {},
    t: (input) => input,
    i18n: {},
  }

  constructor(props) {
    super(props)

    const now = new Date()
    const suffixes = `｜${props.t('common:PopDaily')} ${props.t('common:波波黛莉')}`
    const publisherName = `${props.t('common:publisherName', {
      locales: props.t(`common:${props.i18n.language}`),
    })}`

    this.now = now.getTime()

    this.suffixes = suffixes

    this.PlaceFormatldJSON = {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: suffixes,
      mainEntityOfPage: '',
      datePublished: moment(now).toISOString(),
      author: [],
      keywords: [], // note: feature to add
      image: {},
      publisher: {
        '@type': 'Organization',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.popdaily.com.tw/statics/images/popdaily-logo.svg',
          width: 300,
        },
        name: publisherName,
      },
      articleBody: '',
    }
  }

  render() {
    const { place, placeType, queryPlaceId } = this.props
    // Post Cover Img
    const coverImage =
      placeType === PlaceType.choice
        ? imageUrl(place.getIn(['img', 0, 'path'], appUrl.fbShareDefaultUrl))
        : appUrl.fbShareDefaultUrl
    const coverWidth = place.getIn(['img', 0, 'w'], 700)
    const coverHeight = place.getIn(['img', 0, 'h'], 369)
    // Title and Descript
    const title = `${place.getIn(['place', 'name'])}${this.suffixes}`
    const postDescription = `${place.getIn(['place', 'name'])},${place.getIn([
      'place',
      'comment',
    ])},${place.getIn(['place', 'phone'])},${place.getIn(['place', 'addr'])}`
    const pureDescriptionContext = parserToContext(postDescription)
    // Post Url
    const { asPath = '' } = this.props.router
    const placeUrl = `${appUrl.hostUrl}${asPath}`.split('?')[0]
    // [ld+JSON]
    // >>> title
    this.PlaceFormatldJSON.headline = title
    // >>> description
    this.PlaceFormatldJSON.articleBody = pureDescriptionContext
    // >>> url
    this.PlaceFormatldJSON.mainEntityOfPage = placeUrl
    // >>> time
    this.PlaceFormatldJSON.datePublished = moment(place.getIn(['t'], this.now)).toISOString()
    this.PlaceFormatldJSON.datePublished = moment(place.getIn(['ut'], this.now)).toISOString()
    // >>> coverImg
    this.PlaceFormatldJSON.image['@type'] = 'ImageObject'
    this.PlaceFormatldJSON.image.url = coverImage
    this.PlaceFormatldJSON.image.width = coverWidth
    this.PlaceFormatldJSON.image.height = coverHeight
    // >>> author
    this.PlaceFormatldJSON.author = [place.getIn(['place', 'name'], this.now)]
    const __html = JSON.stringify(this.PlaceFormatldJSON)

    return (
      <React.Fragment>
        <NextHead>
          <title key="title">{title}</title>
          <meta
            key="description"
            name="description"
            content={pureDescriptionContext.substr(0, 100)}
          />
          <meta key="og:type" property="og:type" content="article" />
          <meta key="og:url" property="og:url" content={placeUrl} />
          <meta key="og:title" property="og:title" content={title} />
          <meta
            key="og:description"
            property="og:description"
            content={pureDescriptionContext.substr(0, 100)}
          />
          <meta key="og:image" property="og:image" content={coverImage} />
          <meta key="twitter:title" property="twitter:title" content={title} />
          <meta
            key="twitter:description"
            property="twitter:description"
            content={pureDescriptionContext.substr(0, 100)}
          />
          <meta key="twitter:image" property="twitter:image" content={coverImage} />
          <script key="PlaceHead" type="application/ld+json" dangerouslySetInnerHTML={{ __html }} />
          <link key="canonical" rel="canonical" href={publicUrl(`/place/${queryPlaceId}`)} />
        </NextHead>
        <BreadcrumbJsonLD />
      </React.Fragment>
    )
  }
}

export default compose(
  withTranslation(),
  getContext({
    router: PropTypes.shape(),
  }),
)(PlaceHead)
